/**
 * global.js — Atisse
 * Lógica base sin estilo. Controla la apertura/cierre del cart drawer (sidecart)
 * y del menú móvil mediante atributos data-*. Amplía a medida que construyes.
 */
(function () {
  'use strict';

  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('data-open', 'true');
    document.documentElement.setAttribute('data-drawer-open', 'true');
  }

  function closeDrawer(el) {
    if (!el) return;
    el.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-drawer-open');
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer(document.querySelector('[data-cart-drawer]'));
      return;
    }

    var closeTrigger = event.target.closest('[data-cart-close], [data-drawer-overlay]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer(closeTrigger.closest('[data-cart-drawer]') || document.querySelector('[data-cart-drawer]'));
      return;
    }

    var menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      event.preventDefault();
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) menu.toggleAttribute('data-open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer(document.querySelector('[data-cart-drawer][data-open]'));
    }
  });
})();
